import { Fragment, useState } from 'react'
import { useAppSelector } from '../../ReduxToolkit/Hooks';
import { MenuList } from '../../Data/LayoutData/SidebarData';
import Menulist from './Menulist';
import { MenuItem } from '../../Types/Layout/SidebarType';
import { H6, LI } from '../../AbstractElements';
import { useTranslation } from 'react-i18next';
import { TicketMenuList } from '../../Data/LayoutData/TicketCounterSidebarData';
import { FoodMenuList } from '../../Data/LayoutData/FoodCounterSidebarData';
import { CardAssignMenuList } from '../../Data/LayoutData/CardAssignCounterSidebarData';
import { CardRechargeMenuList } from '../../Data/LayoutData/CardRechargeCounterSidebarData';
import { ClothMenuList } from '../../Data/LayoutData/ClothCounterSidebarData';
import { LockerMenuList } from '../../Data/LayoutData/LockerCounterSidebarData';

const SidebarMenuList = () => {
    const [activeMenu, setActiveMenu] = useState<string[]>([]);
    const { pinedMenu } = useAppSelector((state) => state.layout);
    const { t } = useTranslation();
    const shouldHideMenu = (mainMenu: MenuItem) => {return mainMenu?.Items?.map((data) => data.title).every((titles) =>pinedMenu.includes(titles || ""));};
    const counterStatus = JSON.parse(localStorage.getItem("user")!).counterStatus;
    const role = JSON.parse(localStorage.getItem("user")!).role;
    return (
      <>
      {role === 'Admin' && counterStatus === "Admin" && (
        <>
          {MenuList &&
            MenuList.map((mainMenu: MenuItem, index) => (
              <Fragment key={index}>
                <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
                  <div>
                    <H6 className={mainMenu.lanClass && mainMenu.lanClass}>{t(mainMenu.title)}</H6>
                  </div>
                </LI>
                <Menulist menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu}  level={0}/>
              </Fragment>
            ))}
        </>
      )}
      {role === 'Staff' && (counterStatus === "Ticket Counter2" || counterStatus === "Ticket Counter1") && (
        <>
          {TicketMenuList &&
            TicketMenuList.map((mainMenu: MenuItem, index) => (
              <Fragment key={index}>
                <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
                  <div>
                    <H6 className={mainMenu.lanClass && mainMenu.lanClass}>{t(mainMenu.title)}</H6>
                  </div>
                </LI>
                <Menulist menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu}  level={0}/>
              </Fragment>
            ))}
        </>
      )}
      {role === 'Staff' && counterStatus === "Food Counter" && (
        <>
          {FoodMenuList &&
            FoodMenuList.map((mainMenu: MenuItem, index) => (
              <Fragment key={index}>
                <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
                  <div>
                    <H6 className={mainMenu.lanClass && mainMenu.lanClass}>{t(mainMenu.title)}</H6>
                  </div>
                </LI>
                <Menulist menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu}  level={0}/>
              </Fragment>
            ))}
        </>
      )}
      {role === 'Staff' && counterStatus === "Card Assign" && (
        <>
          {CardAssignMenuList &&
            CardAssignMenuList.map((mainMenu: MenuItem, index) => (
              <Fragment key={index}>
                <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
                  <div>
                    <H6 className={mainMenu.lanClass && mainMenu.lanClass}>{t(mainMenu.title)}</H6>
                  </div>
                </LI>
                <Menulist menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu}  level={0}/>
              </Fragment>
            ))}
        </>
      )}
      {role === 'Staff' && counterStatus === "Card Recharge" && (
        <>
          {CardRechargeMenuList &&
            CardRechargeMenuList.map((mainMenu: MenuItem, index) => (
              <Fragment key={index}>
                <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
                  <div>
                    <H6 className={mainMenu.lanClass && mainMenu.lanClass}>{t(mainMenu.title)}</H6>
                  </div>
                </LI>
                <Menulist menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu}  level={0}/>
              </Fragment>
            ))}
        </>
      )}
      {role === 'Staff' && counterStatus === "Cloth Counter" && (
        <>
          {ClothMenuList &&
            ClothMenuList.map((mainMenu: MenuItem, index) => (
              <Fragment key={index}>
                <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
                  <div>
                    <H6 className={mainMenu.lanClass && mainMenu.lanClass}>{t(mainMenu.title)}</H6>
                  </div>
                </LI>
                <Menulist menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu}  level={0}/>
              </Fragment>
            ))}
        </>
      )}
      {role === 'Staff' && counterStatus === "Locker Counter" && (
        <>
          {LockerMenuList &&
            LockerMenuList.map((mainMenu: MenuItem, index) => (
              <Fragment key={index}>
                <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
                  <div>
                    <H6 className={mainMenu.lanClass && mainMenu.lanClass}>{t(mainMenu.title)}</H6>
                  </div>
                </LI>
                <Menulist menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu}  level={0}/>
              </Fragment>
            ))}
        </>
      )}
      </>
    );
}

export default SidebarMenuList